import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WorkshopJobTemplate } from 'src/app/models/workshop-job-template';
import { ADD_WORKSHOP_JOB_DIALOG } from 'src/testIds';
import { ConfigService } from '../../services/config.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { TestIdDirective } from '../../directives/test-id.directive';
import { TemplateSelectComponent } from './template-select/template-select.component';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-add-workshop-item-dialog',
    templateUrl: './add-workshop-item-dialog.component.html',
    standalone: true,
    imports: [MatDialogTitle, ReactiveFormsModule, MatDialogContent, RouterLink, MatButton, TemplateSelectComponent, TestIdDirective, MatFormField, MatLabel, MatSelect, NgFor, MatOption, MatInput, CdkTextareaAutosize, MatDialogActions, MatDialogClose]
})
export class AddWorkshopItemDialogComponent implements OnDestroy {
  testIds = ADD_WORKSHOP_JOB_DIALOG;

  showTemplateSelect = false;
  private ngUnsubscribe = new Subject<void>();
  types = ['Repair', 'Service', 'Calibration'];
  form = new FormGroup({
    repairable_type: new FormControl(null, Validators.required),
    repairable_id: new FormControl(null, Validators.required),
    booked_in_location: new FormControl(null, Validators.required),
    type: new FormControl(null, Validators.required),
    details: new FormControl(''),
    notes: new FormControl(''),
    template_id: new FormControl(null, Validators.required)
  });

  selectedTemplate: WorkshopJobTemplate;

  constructor(
    private dialog: MatDialogRef<AddWorkshopItemDialogComponent>,
    private configService: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.dialog.updateSize('700px');
    this.configService.currentLocation
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((location) => {
        this.form.patchValue({ booked_in_location: location.id });
      });
    const { repairable_type, repairable_id } = data;
    this.form.patchValue({ repairable_type, repairable_id });
    if (repairable_type === 'item') {
      this.types = [...this.types, 'Pre-hire', 'Off hire'];
    }
    this.form.controls.template_id.disable();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toggleUseTemplate(useTemplate: boolean) {
    this.showTemplateSelect = useTemplate;
    const { template_id, type, details, notes } = this.form.controls;
    this.form.patchValue({ template_id: null });
    if (!useTemplate) {
      [type, details, notes].forEach((control) => control.enable());
      template_id.disable();
    } else {
      [type, details, notes].forEach((control) => control.disable());
      template_id.enable();
    }
  }

  submit() {
    this.data.onSubmit(this.form.value, () => this.dialog.close());
  }

  templateSelected($event: WorkshopJobTemplate) {
    this.selectedTemplate = $event;
    this.form.patchValue({ template_id: $event.id });
  }
}
